export default {
  updateObjectByKey: (state, data) => {
    const { key, obj, val } = data;
    obj[key] = val;
  },
  texteMerzListe: (state, data) => {
    state.texte.merzListe = data;
  },
  werbeMerzListe: (state, data) => {
    state.werbe.merzListe = data;
  },

  ["options"](state, data) {
    $.extend(true, state.options, data);
  },
  //很多情况下是重复更新的
  //特别是页面内改变状态的时候，值并没有改变
  ["updateModusDataByUrl"](state, to) {
    const name = to.name;
    let modusData;
    if (name === "texte-modus") {
      modusData = state.texte.modusData;
    } else if (name === "werbe-modus") {
      modusData = state.werbe.modusData;
    } else {
      return;
    }

    const newUrlparams = to.query;
    const modusId = to.params.modus;
    let active = modusData.modusItems.find(m => m.id === modusId);
    if (!active) {
      active = modusData.modusItems[0];
    }
    modusData.active_modus = active;
    const urlparams = active.option.urlparams;
    Object.keys(newUrlparams).forEach(k => {
      if (newUrlparams[k] === undefined || newUrlparams[k] === "") {
        return;
      }
      if (k.indexOf("b_") > -1) {
        const b = active.option.b.urlparams;
        if (k.indexOf("Idx") > -1) {
          b[k.replace("b_", "")] = parseInt(newUrlparams[k], 10);
        } else {
          b[k.replace("b_", "")] = newUrlparams[k];
        }
      } else {
        if (k.indexOf("Idx") > -1) {
          urlparams[k] = parseInt(newUrlparams[k], 10);
        } else {
          urlparams[k] = newUrlparams[k];
        }
      }
    });
  },

  ['updateObject'](state, { from, to }) {
    for (let opt in from) {
      to[opt] = from[opt];
    }
  },
  ['updateAccoPersonList'](state, { modusOption, perId, merzId, seiteIdx }) {
    const p = modusOption.accoExpandPersonList.find(p => p.merzId === merzId && p.seiteIdx === seiteIdx && p.perId === perId);
    if (p) {
      modusOption.accoExpandPersonList.splice(modusOption.accoExpandPersonList.indexOf(p), 1);
    } else {
      modusOption.accoExpandPersonList.push({
        perId: perId,
        merzId: merzId,
        seiteIdx: seiteIdx
      });
    }
  },

  ['addAccoPersonList'](state, { perId, merzId, seiteIdx, path, query }) {
    const arr = path.split('/');
    let viewKey = arr[1];
    const modusId = arr[arr.length - 1];
    if (viewKey === 'merzwerbe') {
      viewKey = 'werbe';
    }
    let modusOption = state[viewKey].modusData.modusItems.find(m => m.id === modusId).option;
    //vergleichmousd right sidebar
    if (query.b_merzId) {
      modusOption = modusOption.b;
    }

    const p = modusOption.accoExpandPersonList.find(p => p.merzId === merzId && p.seiteIdx === seiteIdx && p.perId === perId);
    if (!p) {
      modusOption.accoExpandPersonList.push({
        perId: perId,
        merzId: merzId,
        seiteIdx: seiteIdx
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js